function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var MenuItem = function (_Emitter) {
  _inherits(MenuItem, _Emitter);

  var _super = _createSuper(MenuItem);

  function MenuItem(rootMenu, parent, insId) {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _super.call(this);
    _this.level = 1;
    _this.parent = null;
    _this.id = '';
    _this.disposed = false;
    _this.parent = parent;
    _this.rootMenu = rootMenu;
    _this.insId = insId || guid();

    _this.init();

    return _this;
  }

  _createClass(MenuItem, [{
    key: "isSubMenu",
    value: function isSubMenu() {
      return false;
    }
  }, {
    key: "updateMenuItemOptions",
    value: function updateMenuItemOptions(options) {
      var id = options.id;
      this.id = id;

      if (this.getActive()) {
        this.setParentActive();
      }

      if (this.opened && this.parent) {
        this.parent.updateOpened(true, true);
      }
    }
  }, {
    key: "getInsId",
    value: function getInsId() {
      return this.insId;
    }
  }, {
    key: "getInsIdsPath",
    value: function getInsIdsPath() {
      var ids = [this.insId];

      if (this.parent) {
        return this.parent.getInsIdsPath().concat(ids);
      }

      return ids;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      return this.rootMenu.getActiveId() === this.id;
    }
  }, {
    key: "setActive",
    value: function setActive() {
      this.rootMenu.setActiveItem(this.insId, this.id);
      this.setParentActive();
    }
  }, {
    key: "setParentActive",
    value: function setParentActive() {
      this.rootMenu.setActiveMenus(null);
      this.parent && this.parent.setActive();
      this.rootMenu.emit('active-menus-update', this.rootMenu.getActiveMenus());
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this.parent;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }, {
    key: "setLevel",
    value: function setLevel() {
      if (this.parent) {
        this.level = this.parent.getLevel() + 1;
      } else {
        this.level = 1;
      }

      this.rootMenu.setDepth(this.level);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      if (this.parent) {
        this.parent.unregister(this);
      }

      this.rootMenu.unregisterMenuItem(this);
      this.disposed = true;
    }
  }, {
    key: "init",
    value: function init() {
      this.setLevel();

      if (this.parent) {
        this.parent.register(this);
      }

      this.rootMenu.registerMenuItem(this);
    }
  }, {
    key: "opened",
    get: function get() {
      return this.rootMenu.isOpened(this.id);
    }
  }]);

  return MenuItem;
}(Emitter);